import { useEffect, useRef, useState } from 'react';
import styles from '../pokemonDropdown.module.scss';

export default function PokemonDropdown({ onSelect }) {
  const [pokemons, setPokemons] = useState([]);
  const [search, setSearch] = useState('');
  const [filtered, setFiltered] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const inputRef = useRef(null);
  const containerRef = useRef(null);

  // Fetch all Pokémon names
  useEffect(() => {
    fetch('https://pokeapi.co/api/v2/pokemon/?limit=9999')
      .then(res => res.json())
      .then(data => {
        const names = data.results.map((p) => p.name);
        // FILTERING OUT MEGA EVOLUTIONS, GIGANTAMAX, AND OTHER VARIANTS
        const filteredNames = names.filter(
          (name) => 
            !name.includes('-mega') && 
            !name.includes('-gmax') &&
            !name.includes('-stellar') &&
            !name.includes('-mode') &&
            !name.includes('-construct') &&
            !name.includes('-build') &&
            !name.includes('-gulping') &&
            !name.includes('-gorging') &&
            !name.includes('-totem') &&
            !name.includes('mimikyu')
        );
        names.push('mimikyu');
        setPokemons(filteredNames);
      });
  }, []);

  // Update filtered list
  useEffect(() => {
    setFiltered(
      pokemons.filter(p => p.toLowerCase().includes(search.toLowerCase()))
    );
  }, [search, pokemons]);

  // Hide dropdown if clicked outside
  useEffect(() => {
    const handler = (e) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={containerRef} className={styles["pokemon-dropdown"]}>
      <input
        className={styles["pokemon-field-answear"]}
        ref={inputRef}
        value={search}
        onChange={e => setSearch(e.target.value)}
        onFocus={() => setShowDropdown(true)}
        placeholder="Search Pokémon"
      />

      {showDropdown && filtered.length > 0 && (
        <ul
          style={{
            listStyle: 'none',
            margin: 0,
            padding: 0,
            position: 'absolute',
            width: '100%',
            maxHeight: '200px',
            overflowY: 'auto',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            zIndex: 10,
          }}
        >
          {filtered.map(name => (
            <li
              key={name}
              onClick={() => {
                setSearch(name);
                setShowDropdown(false);
                onSelect(name);
              }}
              className={styles["dropdown-item"]}
            >
              {name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
